import { render, staticRenderFns } from "./CreateVpnCustomerGateway.vue?vue&type=template&id=1793a909&scoped=true&"
import script from "./CreateVpnCustomerGateway.vue?vue&type=script&lang=js&"
export * from "./CreateVpnCustomerGateway.vue?vue&type=script&lang=js&"
import style0 from "./CreateVpnCustomerGateway.vue?vue&type=style&index=0&id=1793a909&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1793a909",
  null
  
)

export default component.exports